import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import type { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Auth0Store } from '../store';
import { LoginGuard } from './login.guard';

@Service()
export class SIGGuard {
  private loginGuard = inject(LoginGuard);
  private auth0Store = inject(Auth0Store);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return (this.loginGuard.canActivate(route, state) as Observable<boolean>).pipe(
      map((loggedIn) => {
        const userSigs = this.auth0Store.userSigs();
        const value = loggedIn ? userSigs?.includes(route.params.sigId) : false;
        if (!value) {
          this.router.navigate(['/clinical-db']);
        }

        return value;
      }),
      take(1),
    );
  }
}
